import { Banner, Button, HelpIcon, Page, Text } from '@dixa/lib-shared-habla';

import { appActions } from 'app/app.actions';
import { SurveyAddModal } from 'app/views/layout/views/settings/views/satisfaction/survey/components/surveyAddModal/surveyAddModal';
import { SurveyDeleteModal } from 'app/views/layout/views/settings/views/satisfaction/survey/components/surveyDeleteModal/surveyDeleteModal';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { SurveysTable } from '../components/surveysTable';

import { PhoneSurveysTable } from './components/table/phoneSurveysTable';

export const SatisfactionPhoneView = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const openAddSurveyModal = () => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'settings:addSurvey',
        },
      }),
    );
  };
  const flags = useFeatureFlag(['csat-for-phone-via-sms']);

  return (
    <>
      <Page.Section
        title="CSAT survey"
        titleMeta={
          <HelpIcon
            text="Create and edit the surveys that will be used at the end of phone
          calls."
            dark
          />
        }
        controls={
          <Button variant="primary" onClick={openAddSurveyModal}>
            Add survey
          </Button>
        }
      >
        <SurveysTable />
      </Page.Section>

      <Page.Section
        title="Active phone numbers"
        titleMeta={
          <HelpIcon
            text="Select and edit the surveys that will be used in phone calls."
            dark
          />
        }
        callout={
          flags.csatForPhoneViaSms && (
            <Banner
              variant="info"
              description={
                <Text.Paragraph as="span" variant="2">
                  For some countries, having a SMS-capable number enabled at
                  Dixa is a requirement to use SMS.
                  {/* TODO: write article
                  Check out our{' '}
                  <span
                    role="button"
                    data-elevio-article={articles.settings.satisfaction.sms}
                    data-elevio-style="nothing"
                    style={{ textDecoration: 'underline' }}
                  >
                    Help Article
                  </span>{' '}
                  for more information. */}
                </Text.Paragraph>
              }
            />
          )
        }
      >
        <PhoneSurveysTable />
      </Page.Section>

      <SurveyAddModal />
      <SurveyDeleteModal />
    </>
  );
};
